import { Input, InputGroup, InputLeftElement, Stack } from '@chakra-ui/react';
import { Breadcrumbs, Divider } from '@diamond/shared/ui';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { KeyboardEvent, useEffect, useState } from 'react';
import { useDebounce } from 'usehooks-ts';

interface CartSearchProps {
  onSearch: (query: string) => void;
  onClear: () => void;
  searchQuery: string;
  placeholder?: string;
}

const CART_BREADCRUMB_LINKS = [
  {
    title: 'Beranda',
    link: '/',
  },
  {
    title: 'Keranjang',
    link: '/cart',
  },
];

const SEARCH_DEBOUNCE_DELAY = 500;

export const CartSearch = ({
  onSearch,
  onClear,
  searchQuery,
  placeholder = 'Cari Produk di Keranjang',
}: CartSearchProps) => {
  const [localValue, setLocalValue] = useState(searchQuery);
  const debouncedValue = useDebounce(localValue, SEARCH_DEBOUNCE_DELAY);

  useEffect(() => {
    setLocalValue(searchQuery);
  }, [searchQuery]);

  useEffect(() => {
    if (debouncedValue !== searchQuery) {
      onSearch(debouncedValue);
    }
  }, [debouncedValue, onSearch, searchQuery]);

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(localValue);
    }
  };

  return (
    <>
      <Breadcrumbs links={CART_BREADCRUMB_LINKS} />

      <InputGroup mx={0} my="4" maxW={{ md: '527px', lg: '672px' }} w="full">
        <InputLeftElement pointerEvents="none">
          <SearchOutlinedIcon />
        </InputLeftElement>
        <Input
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          bgColor="white"
          aria-label="search_query"
          autoComplete="off"
          borderColor="gray.33"
          type="search"
        />
      </InputGroup>
    </>
  );
};
